import { ReactNode } from 'react'
import { Overlay } from '@/components/overlay'
import { BaseButton } from '@/components/button/BaseButton'
import { css, Theme } from '@emotion/react'

const modalWrapper = (t: Theme) => css`
  background: ${t.c.ec.white};
  border-radius: 8px;
  max-width: 400px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

const titleBar = (t: Theme, color: 'blue' | 'red') => css`
  background: ${color === 'blue' ? t.c.ec.accentBlue : t.c.ec.deepRed};
  color: ${t.c.ec.white};
  padding: 16px;
  text-align: center;
`

const titleStyle = css`
  font-family: 'Noto Sans', sans-serif;
  font-size: 1.8rem;
  font-weight: 300;
  margin: 0;
`

const contentArea = css`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const messageStyle = css`
  font-size: 1.4rem;
  line-height: 1.6;
  margin: 0;
  text-align: center;
`

const buttonGroup = css`
  display: flex;
  justify-content: center;
  gap: 24px;

  button {
    min-width: 150px;
  }
`

type Props = {
  title: string
  titleColor?: 'blue' | 'red'
  message: string | ReactNode
  confirmLabel?: string
  cancelLabel?: string
  confirmColor?: 'outline' | 'danger' | 'primary'
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmModal = ({
  title,
  titleColor = 'blue',
  message,
  confirmLabel = 'はい',
  cancelLabel = 'キャンセル',
  confirmColor = 'outline',
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <Overlay>
      <div css={modalWrapper}>
        <div css={(t) => titleBar(t, titleColor)}>
          <h2 css={titleStyle}>{title}</h2>
        </div>
        <div css={contentArea}>
          <p css={messageStyle}>{message}</p>
          <div css={buttonGroup}>
            <BaseButton size="lg" color="normal" onClick={onCancel}>
              {cancelLabel}
            </BaseButton>
            <BaseButton size="lg" color={confirmColor} onClick={onConfirm}>
              {confirmLabel}
            </BaseButton>
          </div>
        </div>
      </div>
    </Overlay>
  )
}
